import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledDialog = styled(Dialog)`
  .MuiDialog-container {
    width: 100vw;
  }
  min-width: ${(props) => props.width || 'auto'};

  .dialog-wrapper {
    display: flex;
    gap: 22px;
    padding: ${(props) => (props.dialogDevice ? '16px' : '23px 30px')};
  }
  .MuiPaper-root {
    border-radius: ${(props) => props.dialogDevice && '16px'};
  }
  .content-wrapper {
    flex: 1;
    width: ${(props) => props.dialogDevice && '566px'};
  }

  .dialog-title {
    font-weight: 500;
    padding: 0;
    color: ${COLOR.dark};
    margin-left: ${(props) => props.dialogDevice && '16px'};
  }

  .title {
    font-size: 21px;
    margin-bottom: 6px;
    font-weight: 500;
  }
  .title-exceed-devices {
    font-size: 25px;
    margin-bottom: 6px;
    font-weight: 500;
    color: ${COLOR.darkGray};
  }
  .description {
    font-size: 14px;
  }

  .dialog-content {
    padding: ${(props) => (props.dialogDevice ? '0px' : '20px 4px')};
  }

  button {
    text-transform: unset;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    /* margin: ${(props) => props.dialogDevice && '16px'}; */
    button {
      padding: 5px 10px;
    }
    .dialog-wrapper {
      flex-direction: column;
      align-items: center;
      gap: 10px;
      padding: 20px;
    }
    .dialog-title {
      margin-left: 0;
      width: ${(props) => props.dialogDevice && '332px'};
      .MuiTypography-root {
        text-align: ${(props) => props.dialogDevice && 'left'};
      }
    }
    .content-wrapper {
      flex: 1;
      width: ${(props) => props.dialogDevice && 'auto'};
    }
    .title-exceed-devices {
      font-size: 20px;
    }
    .dialog-content {
      width: ${(props) => props.dialogDevice && '100%'};
      display: ${(props) => props.dialogDevice && 'flex'};
      justify-content: ${(props) => props.dialogDevice && 'center'};
    }

    .dialog-title {
      text-align: center;
    }

    .dialog-action {
      justify-content: center;
      align-items: center;
      gap: 10px;
    }

    .MuiPaper-root {
      margin: 10px;
    }
  }
`;
export { StyledDialog };
